import React from "react";
import ReactDOM from "react-dom";
import {connect} from "react-redux";

import Context from "../../../context/Context";
import EventDetails from "../Events/EventDetails";
import GraphicFeature from "./GraphicFeature";
import ItemDetails from "./ItemDetails";
import ItemReference from "../../../aiim/base/ItemReference";
import NonAiimFeature from "./NonAiimFeature";
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import * as component from "../../util/component";
import * as hitTest from "../../../aiim/util/hitTest";
import * as itemUtil from "../../../aiim/util/itemUtil";
import * as mapUtil from "../../../util/mapUtil";
import Icons from "../../util/Icons";
import QRCodePopup from "../QRCode/QRCodePopup";
import * as shareUtil from "./shareUtil";

let COUNTER = 0;

const CSS = {
  main: "i-infopanel",
  expanded: "i-expanded",
  infoPanelOpen: "i-infopanel-open",
  backnext: "i-infopanel-backnext",
  linkDisabled: "disabled",
  getQR: "i-getQR-btn",
  infopanelContainer: "i-infopanel-container"
};

class InfoPanel extends React.Component {

  stack = [];
  stackPosition = -1;

  constructor(props) {
    super(props);
    this.qrCodeRef = React.createRef();
    this.sectionRef = React.createRef();
    this.state = component.newState({
      showFooter: true,
      showQRPopup: false
    });
    this.realTimeToggled = this.realTimeToggled.bind(this);
    this.stackStepBack = this.stackStepBack.bind(this);
    this.stackStepNext = this.stackStepNext.bind(this);
  }

  componentDidMount() {
    this._listen();
  }

  componentWillUnmount() {
    //console.log("InfoPanel::componentWillUnmount");
    component.componentWillUnmount(this);
  }

  fixZ(stackItem) {
    const datasets = Context.getInstance().aiim.datasets
    const categories = datasets.categories;
    const levels = datasets.levels;
    const sourceKey = stackItem && stackItem.sourceKey;
    const searchResult = stackItem && stackItem.searchResult;
    const source = sourceKey && categories.findSourceByKey(sourceKey);
    const feature = searchResult && searchResult.feature;
    if (levels && source && feature) {
      levels.fixZ(source,feature);
    }
  }

  hide(ignoreGraphic) {
    if (!this.props.rdxInfoPanelOpen) return;
    Rdx.setValue(this,Rdx.Keys.INFOPANEL_OPEN,null);
    document.body.classList.remove(CSS.infoPanelOpen);
    if (ignoreGraphic) return;
    const views = Context.getInstance().views;
    mapUtil.clearLocationGraphic(views && views.activeView);
    mapUtil.clearLocationGraphic(views && views.getInactiveView());
  }

  _listen() {
    component.own(this,[

      Topic.subscribe(Topic.CloseInfoPanel,params => {
        this.hide();
      }),

      Topic.subscribe(Topic.DirectionsClicked,params => {
        if (!this.props.rdxInfoPanelOpen) return;
        const uiMode = Context.getInstance().uiMode;
        if (uiMode.modeIsHorizontalSplit() || uiMode.modeIsVerticalSplit()) {
          this.hide();
        }
      }),

      Topic.subscribe(Topic.ReloadViews,params => {
        this.hide(true);
      }),

      Topic.subscribe(Topic.ShowSearchResult,params => {
        this.showSearchResult(params);
      }),

      Topic.subscribe(Topic.ShowInfoPanelGraphic,() => {
        if (!this.props.rdxInfoPanelOpen) return;
        const stackItem = this.stack[this.stackPosition];
        if (stackItem) {
          this.zoomAndHighlight(stackItem,{
            zoom: true,
            highlight: true,
            trackRecent: false
          });
        }
      }),

      Topic.subscribe(Topic.ViewClicked,params => {
        const context = Context.getInstance();
        const allowNonAiim = context.config.allowNonAiimIdentify;
        hitTest.search(params.view,params.event,allowNonAiim).then(hits => {
          if (hits && hits.length > 0) {
            const hit = hits[0];
            const zoom = !!(hit.source && hit.source.isAiimFacilities());
            this.showSearchResult({
              sourceKey: hit.sourceKey,
              searchResult: hit.searchResult,
              isNonAiimFeature: !!hit.isNonAiimFeature,
              zoom: zoom,
              highlight: true,
              trackRecent: true
            });
          } else {
            let item = new ItemReference();
            let pointGeometry = null;
            if(params.event && params.event.mapPoint){
              pointGeometry = params.event.mapPoint;
            } else if(params.event && params.event.screenPoint){
              pointGeometry = params.view.toMap(params.event.screenPoint);
            }
            if(pointGeometry){
              item.fromGeometry(pointGeometry);
              this.showSearchResult({
                sourceKey: item.sourceKey,
                searchResult: item.searchResult,
                zoom: true,
                highlight: true,
                trackRecent: true
              });
            }
          }

        }).catch(ex => {
          console.log("Mapclick error:");
          console.error(ex);
        });
      }),

      Topic.subscribe(Topic.LevelSelected, info => {
        Topic.publish(Topic.ClearToast,{});
        const stackItem = this.stack[this.stackPosition];
        if (!this.props.rdxInfoPanelOpen) return;
        if(!stackItem) return;
        if(stackItem.isNonAiimFeature) return;
        const view = Context.getInstance().views.activeView;
        const inactiveView = Context.getInstance().views.getInactiveView();
        const searchResult = stackItem.searchResult;
        const feature = searchResult && searchResult.feature;
        try {
           if(stackItem && feature && feature.geometry){
              let isSameLevel= (stackItem && stackItem.levelData && stackItem.levelData.levelId) ===
                (info && info.levelData && info.levelData.levelId);
              let options= {
                text:stackItem.title,
                levelData: stackItem.levelData,
                isDifferentLevel: !isSameLevel
              }

              if(view && view.type ==="2d"){
                if(options && options.isDifferentLevel){
                  const i18n = Context.getInstance().i18n;
                  let msg= i18n.map.nameIsOnFloorPattern;
                  msg=msg.replace("{name}",options.text).replace("{floor}",options.levelData.levelNumber);
                  Topic.publish(Topic.ShowToast,{
                    message: msg
                  });
                }
                mapUtil.addLocationGraphic(view,feature.geometry,options)
              }
              if(inactiveView && inactiveView.type ==="2d"){
                mapUtil.addLocationGraphic(inactiveView,feature.geometry,options)
              }
            }
        }
        catch(ex) {
          console.error("ViewMode::Topic.LevelSelected",ex);
        }
      })
    ]);
  }

   makeContent(stackItem) {
    // TODO the feature may have changed since it was last viewed,
    // when should it be refreshed?
    try {
      const isNonAiimFeature = stackItem.isNonAiimFeature;
      const infoPanelKey = stackItem.infoPanelKey;
      const sourceKey = stackItem.sourceKey;
      const searchResult = stackItem.searchResult;
      const backNextButtons = this.makeBackNextButtons();
      const isBookWorkspacePanel = stackItem.isBookWorkspacePanel;
      if (isNonAiimFeature) {
        return (
          <NonAiimFeature key={infoPanelKey} infoPanelKey={infoPanelKey}
            searchResult={searchResult} backNextButtons={backNextButtons} />
        );
      }
      else if (sourceKey === "standalone") {
        const item = new ItemReference();
        item.fromGeometry(stackItem.searchResult.feature.geometry,{
          uniqueId: stackItem.searchResult.key,
          name: stackItem.searchResult.name,
          standaloneNumber: stackItem.searchResult.standaloneNumber
        });
        return (
          <GraphicFeature key={infoPanelKey} infoPanelKey={infoPanelKey}
            searchResult={searchResult} item={item} backNextButtons={backNextButtons} />
        );
      }
      else {
        const item = new ItemReference();
        item.fromSearchResult(sourceKey,searchResult);
        stackItem.title=item.getTitle();
        if (sourceKey === "Events") {
          return (
            <div className={CSS.infopanelContainer}>
              <EventDetails key={infoPanelKey} infoPanelKey={infoPanelKey} item={item} backNextButtons={backNextButtons} />
            </div>
          );
        } else {
          return (
            <div className={CSS.infopanelContainer}>
              <ItemDetails key={infoPanelKey} infoPanelKey={infoPanelKey} item={item}
                realTimeToggled={this.realTimeToggled} backNextButtons={backNextButtons}
                isBookWorkspacePanel={isBookWorkspacePanel} />
            </div>
          );
        }
      }
    } catch(ex) {
      console.error("Error creating InfoPanel content:",ex);
    }
    return null;
  }

  newInfoPanelKey() {
    return "InfoPanel-" + COUNTER++;
  }

  realTimeToggled(mode) {
    this.setState(state => {
      return {
        showFooter: (mode !== "realtime")
      };
    });
  }

  getTitle() {
    if (this.stack.length === 0) return null;
    const stackItem = this.stack[this.stackPosition];
    try {
      const sourceKey = stackItem.sourceKey;
      const searchResult = stackItem.searchResult;
      if (sourceKey === "standalone") {
        return stackItem.searchResult.name
      }
      else {
        const item = new ItemReference();
        item.fromSearchResult(sourceKey,searchResult);
        return item.getTitle();
      }
    } catch (ex) {
      console.error("Error getting title")
    }
    return null
  }

  render() {
    const style = {};
    if (!this.props.rdxInfoPanelOpen) return null;
    //if (!this.props.rdxInfoPanelOpen) style.display = "none";
    const content = this.renderContent();
    if (!content) return null;
    //if (!content) style.display = "none";
    const expanded = this.props.rdxSidebarPanelsExpanded;
    const className = expanded ? CSS.main + " " + CSS.expanded : CSS.main;

    // const stackItem = this.stack[this.stackPosition];
    // let headerLabelId;
    // if (stackItem) headerLabelId = stackItem.infoPanelKey+"-header-label";
    // aria-describedby={headerLabelId}

    const shareItem = this.getShareItem();
    if (!shareItem) return null
    const shareUrl = shareItem.shareUrl;
    let showQR = false;
    const isKiosk = Context.getInstance().uiMode.isKiosk;
    let isQRCodeEnabled;
    if(isKiosk){
      isQRCodeEnabled = Context.getInstance().config.kiosk.kioskQRCode.enabled;
      showQR = shareUrl && isQRCodeEnabled;
    }else{
      const userAgent = navigator.userAgent.toLowerCase();
      const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
      if(isTablet) showQR = shareUrl && true;
      else showQR = shareUrl && !Context.instance.uiMode.isMobile;
    }

    const ariaLabel = this.getTitle() + ", item details open"
    return (
      <section className={className} style={style} aria-live="polite"
        role="complementary" aria-label={ariaLabel} tabIndex="-1" ref={this.sectionRef}>
        {content}
        {showQR ? this.renderFooter() : null}
      </section>
    );
  }

  getShareItem() {
    if (this.stack.length === 0) return null;
    const stackItem = this.stack[this.stackPosition];
    const sourceKey = stackItem.sourceKey;
    const searchResult = stackItem.searchResult;
    const item = new ItemReference();
    item.fromSearchResult(sourceKey,searchResult);
    const shareUrl = shareUtil.generateShareUrl(item)

    return {stackItem: stackItem, shareUrl: shareUrl}
  }

  renderContent() {
    if (this.stack.length === 0) return null;
    const stackItem = this.stack[this.stackPosition];
    return this.makeContent(stackItem)
  }

  makeBackNextButtons() {
    const i18n = Context.getInstance().i18n;
    const hashref = "#";
    let backClass = "i-back", nextClass = "i-next";
    let isAriaBack = false, isAriaNext = false;
    if (!this.stackCanStepBack()) {
      backClass += " " + CSS.linkDisabled;
      isAriaBack = true;
    }
    if (!this.stackCanStepNext()) {
      nextClass += " " + CSS.linkDisabled
      isAriaNext = true;
    }

    const backStyle = {transform: "rotateY(180deg)"};
    let backIcon = (
      <svg className="icon" style={backStyle}>
        <use href="libs/calcite-ui-icons/icons/sprite-16.svg#chevron-16-f"></use>
      </svg>
    );
    let nextIcon = (
      <svg className="icon">
        <use href="libs/calcite-ui-icons/icons/sprite-16.svg#chevron-16-f"></use>
      </svg>
    );
    if (Context.getInstance().uiMode.isRtl) {
      let tmp = backIcon
      backIcon = nextIcon;
      nextIcon = tmp;
    }

    if (Context.getInstance().uiMode.isRtl) {
      return (
        <div className={CSS.backnext}>
          <a className={nextClass} href={hashref} aria-disabled = {isAriaNext}
            role="button" tabIndex="0" onClick={this.stackStepNext} 
            aria-label={i18n.infoPanel.ariaLabelNextButton}>
              {i18n.general.next}
              {nextIcon}
          </a>
          <a className={backClass} href={hashref} aria-disabled = {isAriaBack}
            role="button" tabIndex="0" onClick={this.stackStepBack} 
            aria-label={i18n.infoPanel.ariaLabelBackButton}>
              {backIcon}
              {i18n.general.back}
          </a>
        </div>
      );
    } else {
      return (
        <div className={CSS.backnext}>
          <a className={backClass} href={hashref} aria-disabled = {isAriaBack}
            role="button" tabIndex="0" onClick={this.stackStepBack} 
            aria-label={i18n.infoPanel.ariaLabelBackButton}>
              {backIcon}
              {i18n.general.back}
          </a>
          <a className={nextClass} href={hashref} aria-disabled = {isAriaNext}
            role="button" tabIndex="0" onClick={this.stackStepNext} 
            aria-label={i18n.infoPanel.ariaLabelNextButton}>
              {i18n.general.next}
              {nextIcon}
          </a>
        </div>
      );
    }
  }

  showQR = (event) => {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
        if(this.qrCodeRef && this.qrCodeRef.current && this.qrCodeRef.current.focus){
          event.preventDefault();
          setTimeout(()=>{
            this.qrCodeRef.current.focus();
          }, 1);
        }
      }
    };

    const QRSize = 300
    const shareItem = this.getShareItem()
    const stackItem = shareItem.stackItem
    const shareUrl = shareItem.shareUrl

    if (stackItem && shareItem) {
      ReactDOM.render((
        <QRCodePopup 
          caption={stackItem.searchResult.name} 
          shareUrl={shareUrl} 
          QRSize={QRSize} 
          closePopup={onClose} 
        />
      ), node);
    }
  }

  renderFooter() {
    if (!this.state.showFooter) return null;
    const i18n = Context.getInstance().i18n;
    const hashref = "#"
    
    return (
      <div className={CSS.getQR}>
        <button ref={this.qrCodeRef} onClick={this.showQR}>
          <div>{i18n.QRCode.scanPrompt}</div>  
          <div>{Icons.scanQR()}</div>
        </button>
      </div>
    )
  }

  showSearchResult(params) {
    try {
      const stackItem = params;
      this.fixZ(stackItem);
      //console.log("InfoPanel::showSearchResult.stackItem",stackItem);
      if (stackItem) {
        stackItem.infoPanelKey = this.newInfoPanelKey();
        this.stackAdd(stackItem);
        //Rdx.setValue(this,Rdx.Keys.INFOPANEL_ACTIVE_KEY,key);
        if (!this.props.rdxInfoPanelOpen) {
          Rdx.setValue(this,Rdx.Keys.INFOPANEL_OPEN,true);
          this.updateBodyClass(true);
        } else {
          component.refresh(this);
        }
        this.realTimeToggled();
        this.zoomAndHighlight(stackItem,params);
        setTimeout(() => {
          if (this.sectionRef && this.sectionRef.current && this.sectionRef.current.focus) {
            this.sectionRef.current.focus();
          }
        }, 100)
        
      }
    } catch(ex) {
      console.error("Error showing InfoPanel:",ex);
    }
  }

  stackAdd(stackItem) {
    const len = this.stack.length;
    const pos = this.stackPosition;
    if ((pos + 1) < len) {
      this.stack.splice(pos + 1);
    }
    this.stack.push(stackItem);
    this.stackPosition++;
  }

  stackCanStepBack() {
    return (this.stackPosition > 0);
  }

  stackCanStepNext() {
    const len = this.stack.length;
    const pos = this.stackPosition;
    return (len > 0 && (pos + 1) < len);
  }

  stackStepBack() {
    if (this.stackCanStepBack()) {
      this.stackPosition--;
      const stackItem = this.stack[this.stackPosition];
      //Rdx.setValue(this,Rdx.Keys.INFOPANEL_ACTIVE_KEY,content.props.infoPanelKey);
      this.realTimeToggled();
      component.refresh(this);
      this.zoomAndHighlight(stackItem,{
        zoom: true,
        highlight: true,
        trackRecent: true
      });
    }
  }

  stackStepNext() {
    if (this.stackCanStepNext()) {
      this.stackPosition++;
      const stackItem = this.stack[this.stackPosition];
      //Rdx.setValue(this,Rdx.Keys.INFOPANEL_ACTIVE_KEY,stackItem.infoPanelKey);
      this.realTimeToggled();
      component.refresh(this);
      this.zoomAndHighlight(stackItem,{
        zoom: true,
        highlight: true,
        trackRecent: true
      });
    }
  }

  updateBodyClass(add) {
    const classname = CSS.infoPanelOpen;
    if (add) {
      document.body.classList.add(classname);
    } else {
      document.body.classList.remove(classname);
    }
  }

  zoomAndHighlight(stackItem,params) {
    const sourceKey = stackItem && stackItem.sourceKey;
    const searchResult = stackItem && stackItem.searchResult;
    const feature = searchResult && searchResult.feature;
    const hasGeometry = itemUtil.hasGeometry(sourceKey,feature);
    const view = Context.getInstance().views.activeView;
    const lastCamera = (view && view.camera) ? view.camera.clone() : null;
    const lastExtent2D = (view && view.type === "2d" && view.extent) ? view.extent.clone() : null;
    //console.log("InfoPanel::content.props.searchResult.feature",feature);

    if (!params.publishedFromLevelFilter) {
      const categories = Context.getInstance().aiim.datasets.categories;
      const levels = Context.getInstance().aiim.datasets.levels;
      const source = sourceKey && categories.findSourceByKey(sourceKey);
      if(!stackItem.levelData){
        const zInfo = levels && levels.getZInfo(source,feature);
        stackItem.levelData =zInfo && zInfo.levelData;
      }
      Topic.publish(Topic.ItemOpened,{
        source: source,
        feature: feature,
        lastCamera: lastCamera,
        lastExtent2D: lastExtent2D,
        view: view
      });
    }


    if (view && params.zoom && hasGeometry) {
      mapUtil.goToFeature(view,feature);
    }
    if (view && params.highlight) {
      const inactiveView = Context.getInstance().views.getInactiveView();

      let text = stackItem.title;
      if (!text && stackItem.searchResult && stackItem.searchResult.name) {
        text = stackItem.searchResult.name;
      }
      const options={
        text:text,
        levelData: stackItem.levelData
      }

      if (hasGeometry) {
        mapUtil.addLocationGraphic(view,feature.geometry,options);
        if (inactiveView) mapUtil.addLocationGraphic(inactiveView,feature.geometry,options);
      } else {
        mapUtil.clearLocationGraphic(view);
        if (inactiveView) mapUtil.clearLocationGraphic(inactiveView);
      }
    }

    if (params.trackRecent && hasGeometry && sourceKey && searchResult) {
      const referenceLayer = Context.getInstance().session.referenceLayer;
      referenceLayer.addRecent(sourceKey,searchResult);
    }
  }

}

const mapStateToProps = (state) => {
  return {
    rdxInfoPanelActiveKey: Rdx.getValue(state,Rdx.Keys.INFOPANEL_ACTIVE_KEY),
    rdxInfoPanelOpen: Rdx.getValue(state,Rdx.Keys.INFOPANEL_OPEN),
    rdxSidebarPanelsExpanded: Rdx.getValue(state,Rdx.Keys.SIDEBAR_PANELS_EXPANDED)
  }
}

export default connect(mapStateToProps)(InfoPanel);
